/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InstallmentInterval/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function InstallmentInterval({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/InstallmentInterval",
  isInvalid,
  onChange
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let carrierInstallmentIntervalValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'installment_interval',
})
let carrierInstallmentIntervalIsValidData = fromData.useDataIsValid({ viewPath,
context: 'carrier',
path: 'installment_interval',
validate: fromValidate.textInput,
required: true,
})
let carrierInstallmentIntervalChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'installment_interval',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="options"
 from={optionsValueData}
 data="carrier.installment_interval"
 validate="/Data/validate.js textInput"
 invalid={!carrierInstallmentIntervalIsValidData}
 required={true}
 value={carrierInstallmentIntervalValueData}
 onChange={carrierInstallmentIntervalChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Installment Interval"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}